import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BGColor02,
  blackColor,
  blackShade05,
  blackShade19,
  blackShade21,
  blueColor04,
  border25,
  greyColor39,
  lightRedColor02,
  logoImgborder1,
  mobilePrimary,
  redColor05,
  whiteColor,
} from "../../configs/styles/muiThemes";
import { useDispatch, useSelector } from "react-redux";
import { getActiveBusinessInfo } from "../../reducers/businessPreview/businessPreviewSlice";
import DashboardLayout from "../../components/Layouts/DashboardLayout";
import SyncStepper from "./Components/SyncStepper";
import GetSkuDetailsTab from "./SyncNewCatalogTabs/GetSkuDetailsTab";
import axios from "axios";
import SyncSkuTab from "./SyncNewCatalogTabs/SyncSkuTab";
import {
  getNextButtonText,
  prepareCatalogPartnerItemInfo,
  prepareDraftProductList,
  prepareProductDraftList,
  prepareProductSyncData,
  prepareUpdateDraftProductPostData,
  validateDraftOndcProductSpecs,
  validateDraftProductCategoryInfo,
  validateDraftProductInfo,
  validateDraftProductOndcInfo,
} from "../../service/api_calls/CatalogSync/CatalogSyncHelper";
import {
  addNewProductApi,
  deleteProductPhotoApi,
  getGstRatesApi,
  getUnitOfMeasurementApi,
  uploadPendingProductApi,
  uploadProductPhotoApi,
} from "../../service/api_calls/catalog/CatalogAPI";
import SkuSyncSuccess from "./SyncNewCatalogTabs/SkuSyncSuccess";
import { useNavigate } from "react-router-dom";
import { getBusinessProductsByStatusAPI } from "../../service/api_calls/BusinessPreview/BusinessPreviewAPI";
import {
  addNewProductCatalogPartnerApi,
  getBuyMoreProductDetailsApi,
  getCatalogPartnerProductInfo,
  getUnicomInventoryApi,
  uploadProductCatalogPartnerApi,
} from "../../service/api_calls/CatalogSync/CatalogSyncApi";
import ActionButtons from "./Components/ActionButtons";
import AssignCategory from "./SyncNewCatalogTabs/AssignCategory";
import UpdateProductInfo from "./SyncNewCatalogTabs/UpdateProductInfo";
import { sortByAttribute, toTitleCase } from "../../utils/validationUtils";
import OndcParameters from "./SyncNewCatalogTabs/OndcParameters";
import ONDCSpecGroups from "./SyncNewCatalogTabs/ONDCSpecGroups";
import AddOndcSpecifications from "./SyncNewCatalogTabs/AddOndcSpecifications";
import { getCountryNames } from "../../reducers/catalog/CatalogSlice";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import InfoMessageCard from "./Components/InfoMessageCard";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const SyncNewCatalog = () => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    activeBusinessInfo,
    commerceInfo,
    activeBusinessProductsLoader,
    activeBusinessProducts,
  } = useSelector((state) => state.businessPreview);

  const { countryList } = useSelector((state) => state.catalog);
  const { inventorySummary } = useSelector((state) => state.inventory);

  const businessId = sessionStorage.getItem("selectedBusinessId");

  const [currentPage, setCurrentPage] = useState("provide-sku");

  const [skuText, setSkuText] = useState("");
  const [skuTextErr, setSkuTextErr] = useState("");

  const [isError, setIsError] = useState("");

  const [draftProducts, setDraftProducts] = useState([]);
  const [selectedRows, setSelectedRows] = useState(0);

  const [notSycedProducts, setNotSycedProducts] = useState(null);
  const [alreadySyncedSkus, setAlreadySyncedSkus] = useState(null);
  const [invalidSkus, setInvalidSkus] = useState(null);
  const [rejectedSkus, setRejectedSkus] = useState(null);

  const [productsAdded, setProductsAdded] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [ondcSpecLoader, setOndcSpecLoader] = useState(false);

  const [openCategoryModal, setOpenCategoryModal] = useState(false);
  const [openQuickProductUpdateModel, setOpenQuickProductUpdateModel] =
    useState(false);

  const [unitOfMeasurementData, setUnitOfMeasurementData] = useState([]);
  const [categoryError, setCategoryError] = useState("");
  const [showSnackBar, setShowSnackBar] = useState(false);

  // used for ondc specs update
  const [selectedProdGroup, setSelectedProdGroup] = useState(null);
  const [openQuickSpecUpdateModal, setOpenQuickSpecUpdateModal] =
    useState(false);
  const [selectedOndcSpecCount, setSelectedOndcSpecCount] = useState(0);
  const [ondcSpecError, setOndcSpecError] = useState("");
  const [isDynamicSpecEmpty, setIsDynamicSpecEmpty] = useState(true);

  const [openQuickOndcParamUpdateModel, setOpenQuickOndcParamUpdateModel] =
    useState(false);

  const [buyMoreImageLinks, setBuyMoreImageLinks] = useState([])

  // Get only new Sku list - Unicommerce
  const getOnlyNewSkuList = async (skuList) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const ALL_PRODUCT_STATUS = ["active", "new", "updated", "draft"];
    // const ALL_PRODUCT_STATUS = [];

    const updatedSkuList = skuList?.map((newSku) => newSku?.trim());

    const catalogPartnerInfo =
      commerceInfo?.info?.catalogPartnerInfo?.[0] || null;
    const facilityCode = catalogPartnerInfo?.warehouse?.facilityCode || "";

    // Check if the given SKU's present in facility
    const inventoryRes = await getUnicomInventoryApi({
      facilityCode,
      skuList: updatedSkuList,
      businessId,
    });

    console.log("checkIfSkuAlreadySyned__inventoryRes:", inventoryRes);

    const validInventoryProducts = inventoryRes?.inventorySnapshots || [];
    const validInventorySkus = validInventoryProducts
      .filter((item) => updatedSkuList?.includes(item?.itemTypeSKU))
      .map((item) => item?.itemTypeSKU);

    const invalidInventorySkus = [];

    updatedSkuList?.forEach((item) => {
      if (!validInventorySkus?.includes(item)) {
        invalidInventorySkus?.push(item);
      }
    });

    console.log("checkIfSkuAlreadySyned__inventory_validInventorySkus:", {
      validInventorySkus,
      updatedSkuList,
    });

    // Make API requests in parallel
    const result = await Promise.all(
      ALL_PRODUCT_STATUS.map((status) =>
        getBusinessProductsByStatusAPI({
          businessId,
          status,
        })
      )
    );

    // Flatten the list of all product details
    const allProducts = result.flatMap((item) => item?.details || []);

    // Filter out SKUs that are not in allProducts (new SKUs)
    const newSkuList = validInventorySkus.filter(
      (sku) => !allProducts.some((product) => product.skuId === sku)
    );

    const alreadySyncedSkuList = validInventorySkus.filter((sku) =>
      allProducts.some((product) => product.skuId === sku)
    );

    console.log("checkIfSkuAlreadySyned__result", result);
    console.log("checkIfSkuAlreadySyned__skuList", skuList);
    console.log("checkIfSkuAlreadySyned__updatedSkuList", updatedSkuList);
    console.log("checkIfSkuAlreadySyned__allProducts", allProducts);
    console.log("checkIfSkuAlreadySyned__newSkuList", newSkuList);
    console.log("checkIfSkuAlreadySyned__old", alreadySyncedSkuList);
    console.log(
      "checkIfSkuAlreadySyned__invalidInventorySkus",
      invalidInventorySkus
    );

    setAlreadySyncedSkus(alreadySyncedSkuList);

    return { newSkuList, invalidInventorySkus };
  };

  // Pull Unicommerce products to draft table
  const fetchUnicommerceProductsToDraft = async () => {
    try {
      setIsLoading(true);

      const skuList =
        [
          ...new Set(skuText?.split(",")?.filter((item) => item?.trim() != "")),
        ] || [];

      const filterResult = await getOnlyNewSkuList(skuList);

      const newSkuList = filterResult?.newSkuList || [];
      const invalidInventorySkus = filterResult?.invalidInventorySkus || [];

      const results = await Promise.allSettled(
        newSkuList.map(
          (skuCode) =>
            getCatalogPartnerProductInfo({
              businessId,
              catelogPartner: "unicommerce",
              skuCode: skuCode?.trim(),
            })
              .then((response) => ({ skuCode, ...response })) // Attach skuCode to the result
              .catch((error) => ({ skuCode, error })) // Attach skuCode in case of error
        )
      );

      // Filter successful responses
      const successfulProductDataList = results
        .filter(
          (result) =>
            result?.status === "fulfilled" && result?.value?.successful
        )
        .map((result) => ({
          skuCode: result?.value?.skuCode,
          itemTypeDTO: result?.value?.itemTypeDTO,
        }));

      // Filter unsuccessful responses
      const unsuccessfulProductDataList = results
        .filter(
          (result) =>
            result.status === "fulfilled" && result.value?.successful === false
        )
        .map((result) => result.value?.skuCode); // Only keep skuCode

      // Filter failed requests (rejected promises)
      const failedRequests = results
        .filter((result) => result.status === "rejected")
        .map((result) => result.reason.skuCode); // Map the SKU for failed requests

      setNotSycedProducts(successfulProductDataList || []);
      setInvalidSkus([...unsuccessfulProductDataList, ...invalidInventorySkus]);
      setRejectedSkus(failedRequests || []);
      setCurrentPage("sync-sku");
    } catch (error) {
      console.error("Error fetching unsynced products:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Get only new Sku list - Buymore
  const getOnlyNewSkuListBuymore = async (skuList) => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const ALL_PRODUCT_STATUS = ["active", "new", "updated", "draft"];
    // const ALL_PRODUCT_STATUS = [];

    const updatedSkuList = skuList?.map((newSku) => newSku?.trim());

    const catalogPartnerInfo =
      commerceInfo?.info?.catalogPartnerInfo?.[0] || null;
    const facilityCode = catalogPartnerInfo?.warehouse?.facilityCode || "";

    // Check if the given product ids present in buymore
    const buyMoreProductRes = await getBuyMoreProductDetailsApi({
      businessId,
      pageNumber: 1,
      skuList: updatedSkuList,
    });

    const validBuyMoreProducts = buyMoreProductRes?.body || [];
    const buyMoreImageLinks = buyMoreProductRes?.image_links || []

    setBuyMoreImageLinks(buyMoreImageLinks)

    const validInventorySkus = validBuyMoreProducts
      .filter((item) =>
        updatedSkuList?.includes(String(item?.costboondc_portal_sku))
      )
      .map((item) => String(item?.costboondc_portal_sku));

    console.log("checkIfSkuAlreadySyned__buyMoreProductRes:", {
      updatedSkuList,
      validBuyMoreProducts,
    });
    console.log("checkIfSkuAlreadySyned__validInventorySkus:", {
      validInventorySkus,
    });

    const invalidInventorySkus = [];

    updatedSkuList?.forEach((item) => {
      if (!validInventorySkus?.includes(String(item))) {
        invalidInventorySkus?.push(String(item));
      }
    });

    console.log("checkIfSkuAlreadySyned__invalidInventorySkus:", {
      invalidInventorySkus,
    });

    // Make API requests in parallel
    const result = await Promise.all(
      ALL_PRODUCT_STATUS.map((status) =>
        getBusinessProductsByStatusAPI({
          businessId,
          status,
        })
      )
    );

    // Flatten the list of all product details
    const allProducts = result.flatMap((item) => item?.details || []);

    // Filter out SKUs that are not in allProducts (new SKUs)
    const newSkuList = validInventorySkus.filter(
      (sku) => !allProducts.some((product) => product.skuId === sku)
    );

    const alreadySyncedSkuList = validInventorySkus.filter((sku) =>
      allProducts.some((product) => product.skuId === sku)
    );

    console.log("checkIfSkuAlreadySyned_________________________");
    console.log("checkIfSkuAlreadySyned__result", result);
    console.log("checkIfSkuAlreadySyned__skuList", skuList);
    console.log("checkIfSkuAlreadySyned__updatedSkuList", updatedSkuList);
    console.log("checkIfSkuAlreadySyned__allProducts", allProducts);
    console.log("checkIfSkuAlreadySyned__newSkuList", newSkuList);
    console.log("checkIfSkuAlreadySyned__old", alreadySyncedSkuList);
    console.log(
      "checkIfSkuAlreadySyned__invalidInventorySkus",
      invalidInventorySkus
    );

    setAlreadySyncedSkus(alreadySyncedSkuList);

    return { newSkuList, invalidInventorySkus, validBuyMoreProducts };
    // return null
  };

  // Pull Buymore products to draft table
  const fetchBuymoreProductsToDraft = async () => {
    try {
      setIsLoading(true);

      const skuList =
        [
          ...new Set(skuText?.split(",")?.filter((item) => item?.trim() != "")),
        ] || [];

      const filterResult = await getOnlyNewSkuListBuymore(skuList);

      const newSkuList = filterResult?.newSkuList || [];
      const invalidInventorySkus = filterResult?.invalidInventorySkus || [];
      const buyMoreProductsList = filterResult?.validBuyMoreProducts || [];

      // const results = await Promise.allSettled(
      //   newSkuList.map(
      //     (skuCode) =>
      //       getCatalogPartnerProductInfo({
      //         businessId,
      //         catelogPartner: "unicommerce",
      //         skuCode: skuCode?.trim(),
      //       })
      //         .then((response) => ({ skuCode, ...response })) // Attach skuCode to the result
      //         .catch((error) => ({ skuCode, error })) // Attach skuCode in case of error
      //   )
      // );

      const successfulProductDataList = buyMoreProductsList
        ?.filter((item) => newSkuList?.includes(item?.costboondc_portal_sku))
        .map((product) => ({
          itemTypeDTO: {
            ...product,
            imageUrl: product?.image_url || "",
            name: product?.product_name || "",
            skuCode: product?.costboondc_portal_sku || "",
          },
        }));

      console.log("checkIfSkuAlreadySyned____successfulProductDataList", {
        successfulProductDataList,
      });

      // // Filter successful responses
      // const successfulProductDataList = results
      //   .filter(
      //     (result) =>
      //       result?.status === "fulfilled" && result?.value?.successful
      //   )
      //   .map((result) => ({
      //     skuCode: result?.value?.skuCode,
      //     itemTypeDTO: result?.value?.itemTypeDTO,
      //   }));

      // // Filter unsuccessful responses
      // const unsuccessfulProductDataList = results
      //   .filter(
      //     (result) =>
      //       result.status === "fulfilled" && result.value?.successful === false
      //   )
      //   .map((result) => result.value?.skuCode); // Only keep skuCode

      // // Filter failed requests (rejected promises)
      // const failedRequests = results
      //   .filter((result) => result.status === "rejected")
      //   .map((result) => result.reason.skuCode); // Map the SKU for failed requests

      setNotSycedProducts(successfulProductDataList || []);
      // setInvalidSkus([...unsuccessfulProductDataList, ...invalidInventorySkus]);
      setInvalidSkus([...invalidInventorySkus]);
      setRejectedSkus([]);
      setCurrentPage("sync-sku");
    } catch (error) {
      console.error("Error fetching unsynced products:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Get Not Synced Products
  const getNotSyncedProducts = async () => {
    if (!skuText) {
      setSkuTextErr("Enter SKU Ids");
      return;
    }

    setSkuTextErr("");

    const catalogPartnerInfo =
      commerceInfo?.info?.catalogPartnerInfo?.[0] || null;

    if (catalogPartnerInfo?.catalogPartner?.toLowerCase() == "unicommerce") {
      fetchUnicommerceProductsToDraft();
    } else if (catalogPartnerInfo?.catalogPartner?.toLowerCase() == "buymore") {
      fetchBuymoreProductsToDraft();
    }
  };

  // Handle Delete SKU
  const handleDeleteSku = (index) => {
    setNotSycedProducts((prevList) => [
      ...prevList.slice(0, index), // Items before the index
      ...prevList.slice(index + 1), // Items after the index
    ]);

    // setNotSycedProducts((prevList) =>
    //   prevList.filter((product) => product.skuCode !== item.skuCode)
    // );
  };

  // Call Add Product API for all not synced products
  const handleSyncProducts = async (syncPostData) => {
    if (notSycedProducts?.length > 0) {
      setIsLoading(true);

      // const syncPostData = notSycedProducts.map((item) => {
      //   const info = item?.itemTypeDTO;

      //   return prepareProductSyncData({
      //     businessId,
      //     businessInfo: activeBusinessInfo,
      //     commerceInfo: commerceInfo?.info || null,
      //     partnerItemData: info,
      //     productName: info?.name,
      //     brand: info?.brand,
      //     description: info?.description,
      //     enabled: info?.enabled,
      //     weight: info?.weight,
      //     length: info?.length,
      //     width: info?.width,
      //     height: info?.height,
      //     maxRetailPrice: info?.maxRetailPrice,
      //     skuCode: item?.skuCode,
      //   });
      // });

      // Make API requests in parallel
      const result = await Promise.all(
        syncPostData.map((data) => addNewProductCatalogPartnerApi(data))
      );

      const productList = await getProductsInDraftStatus();
      setDraftProducts(productList || []);

      setIsLoading(false);
      setCurrentPage("assign-category");
    }
  };

  const syncProducts = async () => {
    const catalogPartnerInfo =
      commerceInfo?.info?.catalogPartnerInfo?.[0] || null;
    const catalogPartner = catalogPartnerInfo?.catalogPartner?.toLowerCase();

    const gstRates = await getGstRatesApi()

    if (notSycedProducts?.length > 0) {
      const syncPostData = notSycedProducts.map((item) => {
        const info = item?.itemTypeDTO;

        if (catalogPartner == "unicommerce") {
          const partnerItemData = {
            basePrice: info?.basePrice || 0,
            brand: info?.brand || "",
            color: info?.color || "",
            ean: info?.ean || "",
            expirable: info?.expirable || true,
            expiryDate: info?.expiryDate || "",
            fragile: info?.fragile || true,
            gstTaxTypeCode: info?.gstTaxTypeCode || "",
            height: info?.height || "",
            hsn: info?.hsnCode || "",
            isbn: info?.isbn || "",
            length: info?.length || "",
            maxRetailPrice: info?.maxRetailPrice || "",
            minOrderSize: info?.minOrderSize || "",
            description: info?.description || "",
            name: info?.name || "",
            scanType: info?.scanType || "",
            shelfLife: info?.shelfLife || "",
            size: info?.size || "",
            skuCode: info?.skuCode || "",
            skuType: info?.skuType || "",
            taxTypeCode: info?.taxTypeCode || "",
            type: info?.type || "",
            upc: info?.upc || "",
            weight: info?.weight || "",
            width: info?.width || "",
          };

          const catalogPartnerItemInfo = prepareCatalogPartnerItemInfo(
            partnerItemData,
            commerceInfo?.info || null
          );

          const gstTaxTypeCode = info?.gstTaxTypeCode || ''
          // const gstCode = gstTaxTypeCode?.replace('Tax_', '')
          const gstCode = gstTaxTypeCode?.slice(4) || '';

          return prepareProductSyncData({
            businessId,
            businessInfo: activeBusinessInfo,
            // commerceInfo: commerceInfo?.info || null,
            // partnerItemData: info,
            imageUrl: info?.imageUrl,
            catalogPartnerItemInfo,
            productName: info?.name,
            brand: info?.brand,
            description: info?.description || info?.name,
            enabled: info?.enabled,
            weight: info?.weight,
            length: info?.length,
            width: info?.width,
            height: info?.height,
            maxRetailPrice: info?.maxRetailPrice,
            skuCode: item?.skuCode,
            productMeasurementUnit: 'gram',
            productMeasurementValue: info?.weight,
            gst: gstCode || '',
            gstRates: gstRates?.details || []
          });
        } else if (catalogPartner == "buymore") {
          const partnerItemData = {
            basePrice: 0,
            brand: info?.brand_name || "",
            color: "",
            ean: info?.ean || "",
            expirable: true,
            expiryDate: "",
            fragile: true,
            gstTaxTypeCode: "",
            height: info?.product_breath || "",
            hsn: "",
            isbn: "",
            length: info?.product_length || "",
            maxRetailPrice: info?.product_mrp || "",
            minOrderSize: "",
            description: "",
            name: info?.product_name || "",
            scanType: "",
            shelfLife: "",
            size: "",
            skuCode: info?.costboondc_portal_sku || "",
            skuType: "",
            taxTypeCode: "",
            type: "",
            upc: "",
            weight: info?.product_weight || "",
            width: info?.product_width || "",
          };

          const catalogPartnerItemInfo = prepareCatalogPartnerItemInfo(
            partnerItemData,
            commerceInfo?.info || null
          );

          const percent = 10;
          const productWeight = Number(info?.product_weight || 0)
          const result = (percent / 100) * productWeight;

          const shippingWeight = Math.round(productWeight + result);

          return prepareProductSyncData({
            businessId,
            businessInfo: activeBusinessInfo,
            // commerceInfo: commerceInfo?.info || null,
            // partnerItemData: info,
            partnerProductId: info?.product_id || '',
            imageUrl: info?.image_url,
            buyMoreImageLinks: buyMoreImageLinks,
            catalogPartnerItemInfo,
            productName: info?.product_name,
            brand: info?.brand_name,
            description: info?.product_name || "",
            enabled: true,
            weight: info?.product_weight,
            length: info?.product_length,
            width: info?.product_width,
            height: info?.product_breath,
            maxRetailPrice: info?.product_mrp || "",
            skuCode: info?.costboondc_portal_sku,
            shippingWeight: shippingWeight,
            productMeasurementUnit: 'gram',
            productMeasurementValue: info?.product_weight,
            productCode: 'EAN',
            productCodeValue: info?.ean?.replace('_', '') || '',
            gst: info?.gst || '',
            gstRates: gstRates?.details || []
          });
        }
      });

      console.log("checkIfSkuAlreadySyned____syncProducts", {
        syncPostData,
      });

      handleSyncProducts(syncPostData);
    }
  };

  const clearDataAndGotoCatalog = () => {
    setSkuText("");
    setNotSycedProducts([]);
    setInvalidSkus([]);
    navigate(`/${sessionStorage.getItem("costboWEBURL")}/catalogPending`);
  };

  // Calling Add Image and Update Product API
  const updateImagesAndProductInfo = async ({
    addImagePostData,
    updateProduct,
  }) => {
    try {
      const addImageResult = await Promise.all(
        addImagePostData?.map(uploadProductPhotoApi) || []
      );

      const updateRes = await uploadProductCatalogPartnerApi(updateProduct);

      return { addImageResult, updateRes };
    } catch (error) {
      console.error("Error updating images or product info:", error);
      throw error;
    }
  };

  // Import Draft Products
  const importDraftProducts = async (draftProductList) => {
    const postData = prepareUpdateDraftProductPostData(
      draftProductList,
      countryList,
      businessId,
      activeBusinessInfo
    );

    setIsLoading(true);

    // Delete Photos
    for (let i = 0; i < postData.length; i++) {
      const deleteImgData = postData[i];

      const imageDeletionList = deleteImgData?.deleteImagePostData || [];

      for (let j = 0; j < imageDeletionList.length; j++) {
        const deletePost = imageDeletionList[j];
        await deleteProductPhotoApi(deletePost);
      }
    }

    // Make API requests in parallel
    const result = await Promise.all(
      postData.map((data) => updateImagesAndProductInfo(data))
    );

    // // Make API requests in parallel
    // const result = await Promise.all(
    //   postData.map((data) => uploadProductCatalogPartnerApi(data))
    // );

    setProductsAdded(result);
    setIsLoading(false);
    setCurrentPage("done");
  };

  // Handle Next Click
  const handleNext = () => {
    if (currentPage === "provide-sku") {
      getNotSyncedProducts();
      return;
    }

    if (currentPage === "sync-sku") {
      // handleSyncProducts();
      syncProducts();
      return;
    }

    if (currentPage === "assign-category") {
      const isProductInfoValid =
        validateDraftProductCategoryInfo(draftProducts);

      if (!isProductInfoValid?.isError) {
        setDraftProducts(
          (prevSatte) => isProductInfoValid?.allProducts || [...prevSatte]
        );
        setCurrentPage("product-info");
      } else {
        setDraftProducts(
          (prevSatte) => isProductInfoValid?.allProducts || [...prevSatte]
        );
      }

      return;
    }

    if (currentPage === "product-info") {
      const isProductInfoValid = validateDraftProductInfo(
        draftProducts,
        unitOfMeasurementData
      );

      if (!isProductInfoValid?.isError) {
        setDraftProducts(
          (prevSatte) => isProductInfoValid?.allProducts || [...prevSatte]
        );
        setCurrentPage("ondc");
      } else {
        setDraftProducts(
          (prevSatte) => isProductInfoValid?.allProducts || [...prevSatte]
        );
      }

      return;
    }

    if (currentPage === "ondc") {
      const isProductInfoValid = validateDraftProductOndcInfo(
        draftProducts,
        true
      );

      if (!isProductInfoValid?.isError) {
        setDraftProducts(
          (prevSatte) => isProductInfoValid?.allProducts || [...prevSatte]
        );
        setCurrentPage("ondcSpecGroup");
      } else {
        setDraftProducts(
          (prevSatte) => isProductInfoValid?.allProducts || [...prevSatte]
        );
      }

      return;
    }

    if (currentPage === "ondcSpecGroup") {
      if (selectedProdGroup) {
        setCurrentPage("addOndcSpecs");
      } else {
        setIsError("Please select a product group to proceed");
      }
    }

    if (currentPage === "addOndcSpecs") {
      if (selectedProdGroup) {
        const isProductInfoValid = validateDraftOndcProductSpecs(
          selectedProdGroup?.products || []
        );

        if (!isProductInfoValid?.isError) {
          setSelectedProdGroup((prevState) => ({
            ...prevState,
            products: isProductInfoValid?.updatedProductList,
          }));

          importDraftProducts(isProductInfoValid?.updatedProductList || []);
        } else {
          setSelectedProdGroup((prevState) => ({
            ...prevState,
            products: isProductInfoValid?.updatedProductList,
          }));
        }
      }

      return;
    }
  };

  const goBack = () => {
    setIsError("");
    switch (currentPage) {
      case "addOndcSpecs":
        setCurrentPage("ondcSpecGroup");
        break;

      case "ondcSpecGroup":
        setCurrentPage("ondc");
        break;

      case "product-info":
        setCurrentPage("assign-category");
        break;

      case "ondc":
        setCurrentPage("product-info");
        break;

      case "ondcSpecifications":
        setCurrentPage("ondc");
        break;

      case "assign-category":
        setCurrentPage("assign-category");
        break;

      case "sync-sku":
        setCurrentPage("provide-sku");
        break;

      case "download":
        setCurrentPage("download");
        break;

      default:
        break;
    }
  };

  const getProductsInDraftStatus = async () => {
    const response = await getBusinessProductsByStatusAPI({
      businessId,
      status: "draft",
    });

    const draftProductArr = prepareProductDraftList(
      response?.details || [],
      countryList
    );

    return draftProductArr;
  };

  // Handle Select All Product
  const selectAllProductRows = (isSelected) => {
    const allProducts = draftProducts?.map((item) => ({
      ...item,
      isSelected: isSelected ? true : false,
    }));

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setDraftProducts((prevState) => allProducts);
    setSelectedRows(selectedCount);
  };

  // Toggle Indiviual Row Selection
  const toggleProductRowSelect = (index, isSelected) => {
    const allProducts = [...draftProducts];
    const productInfo = allProducts[index] || null;

    if (!productInfo) {
      setDraftProducts(allProducts || []);
      return;
    }

    const updatedProductInfo = {
      ...productInfo,
      isSelected: !isSelected,
    };

    allProducts[index] = updatedProductInfo;

    const selectedCount = allProducts?.filter(
      (item) => item?.isSelected
    ).length;

    setDraftProducts(allProducts || []);
    setSelectedRows(selectedCount);
  };

  // Update Product Array
  const updateDraftProductListInfo = (newProductArray) => {
    setDraftProducts((prevSatte) => newProductArray || [...prevSatte]);
  };

  // Get Unit of measurement
  const getUnitsData = async () => {
    const response = await getUnitOfMeasurementApi();
    const sortedList = sortByAttribute([...response?.details], "value");

    setUnitOfMeasurementData(() => sortedList || []);
  };

  const fetchRequiredData = async () => {
    dispatch(getCountryNames());

    if (businessId) {
      if (!activeBusinessInfo) {
        dispatch(getActiveBusinessInfo(businessId));
      }

      // Testing purpose
      const productList = await getProductsInDraftStatus();
      setDraftProducts(productList || []);
    }

    getUnitsData();
  };

  const handleNavigation = (route) => {
    navigate(`/${sessionStorage.getItem("costboWEBURL")}/${route}`);
  };

  useEffect(() => {
    fetchRequiredData();
    return () => {};
  }, []);

  const getActiveScreen = () => {
    const catalogPartnerStatus =
      commerceInfo?.info?.catalogPartnerInfo?.[0]?.status || "";
    const totalProducts = inventorySummary?.totalProduct || 0;

    // Info Message to Add Catalog Partner
    if (catalogPartnerStatus != "active" && totalProducts == 0) {
      setCurrentPage("add-controls");
    } else if (catalogPartnerStatus != "active" && totalProducts > 0) {
      // Catalog Already Defined with costbo - Sync not valid
      navigate(`/${sessionStorage.getItem("costboWEBURL")}/catalog`);
    } else if (catalogPartnerStatus == "active") {
      if (commerceInfo?.info?.ondcEnabled?.toLowerCase() == "yes") {
        setCurrentPage("provide-sku");
        // setCurrentPage("assign-category");
      } else {
        setCurrentPage("ondc-alert");
      }
    }
  };

  useEffect(() => {
    if (commerceInfo && inventorySummary) {
      getActiveScreen();
    }
    return () => {};
  }, [commerceInfo, inventorySummary]);

  return (
    <Box sx={styles.container(matches)}>
      <DashboardLayout activeMenu="catalog" activeSubMenu="catalogSync">
        <Box sx={styles.content}>
          <Box>
            <Typography
              component="h4"
              fontSize={{ xs: 14.5, md: 17 }}
              color={blackShade05}
              fontWeight={600}
              lineHeight="20px"
              pt={{ xs: 1, md: 2 }}
            >
              Product Catalog Sync
            </Typography>

            {currentPage != "add-controls" && (
              <>
                <Typography
                  fontSize={{ xs: 12, md: 14 }}
                  fontWeight={{ xs: 500, md: 600 }}
                  color={blackColor}
                  lineHeight={{ xs: "17px", md: "24px" }}
                  mt={0.6}
                >
                  Catalog Partner -{" "}
                  <span
                    style={{ color: matches ? blueColor04 : mobilePrimary }}
                  >
                    {toTitleCase(
                      commerceInfo?.info?.catalogPartnerInfo?.[0]
                        ?.catalogPartner || ""
                    ) || "-"}
                  </span>
                  , Facility Name -{" "}
                  <span
                    style={{ color: matches ? blueColor04 : mobilePrimary }}
                  >
                    {toTitleCase(
                      commerceInfo?.info?.catalogPartnerInfo?.[0]?.warehouse
                        ?.facilityName || ""
                    ) || "-"}
                  </span>
                </Typography>

                <Typography
                  fontSize={13}
                  fontWeight={500}
                  color={blackShade21}
                  display={{ xs: "none", md: "block" }}
                >
                  Base catalog details are fetched from{" "}
                  {toTitleCase(
                    commerceInfo?.info?.catalogPartnerInfo?.[0]
                      ?.catalogPartner || ""
                  )}
                  . You may edit{" "}
                  <span
                    style={{ color: matches ? blueColor04 : mobilePrimary }}
                  >
                    Categories and ONDC parameters
                  </span>{" "}
                  through EDIT option
                </Typography>
              </>
            )}
          </Box>
          {activeBusinessInfo && commerceInfo && countryList?.length > 0 && (
            <>
              {matches ? (
                <Box>
                  {currentPage == "add-controls" && (
                    <Box sx={{ ...styles.card, mt: 1, pb: "50px" }}>
                      <InfoMessageCard
                        icon={
                          <CategoryOutlinedIcon
                            sx={{ fontSize: "30px", color: blueColor04 }}
                          />
                        }
                        title="Add Catalog Controls"
                        message="Provide the catalog partner details to easily sync all your existing products with CostBo."
                        btnText="ADD CONTROLS"
                        onClick={() => handleNavigation("editCatalogControls")}
                      />
                    </Box>
                  )}

                  {commerceInfo && currentPage != "add-controls" && (
                    <Box sx={styles.card}>
                      {currentPage != "ondc-alert" && (
                        <SyncStepper currentPage={currentPage} />
                      )}

                      <Box mt={2}>
                        {currentPage == "ondc-alert" && (
                          <Box pb={3}>
                            <InfoMessageCard
                              icon={
                                <SettingsOutlinedIcon
                                  sx={{ fontSize: "30px", color: redColor05 }}
                                />
                              }
                              iconBGColor={lightRedColor02}
                              title="Enable ONDC"
                              message="Please enable ONDC controls at business level to continue with the catalog sync"
                              btnText="GOTO ONDC CONTROLS"
                              onClick={() => handleNavigation("ONDCControls")}
                            />
                          </Box>
                        )}

                        {currentPage == "provide-sku" && (
                          <GetSkuDetailsTab
                            currentPage={currentPage}
                            draftProducts={draftProducts}
                            skuData={skuText}
                            setSkuData={setSkuText}
                            error={skuTextErr}
                            setError={setSkuTextErr}
                            onNext={() => {
                              handleNext();
                            }}
                            loader={isLoading}
                            handleContinueWithDraft={() => {
                              setCurrentPage("assign-category");
                            }}
                            commerceInfo={commerceInfo}
                          />
                        )}

                        {currentPage == "sync-sku" && (
                          <SyncSkuTab
                            notSycedProducts={notSycedProducts}
                            alreadySyncedSkus={alreadySyncedSkus}
                            invalidSkus={invalidSkus}
                            onSyncSku={() => {
                              // handleSyncProducts();
                            }}
                            onGoBack={() => {
                              setCurrentPage("provide-sku");
                            }}
                            handleDeleteSku={handleDeleteSku}
                            loader={isLoading}
                          />
                        )}

                        {currentPage == "assign-category" && (
                          <AssignCategory
                            productDetails={draftProducts}
                            isLoading={isLoading}
                            businessInfo={activeBusinessInfo}
                            openCategoryModal={openCategoryModal}
                            setOpenCategoryModal={setOpenCategoryModal}
                            setCurrentPage={setCurrentPage}
                            selectAllProductRows={selectAllProductRows}
                            toggleProductRowSelect={toggleProductRowSelect}
                            selectedRowCount={selectedRows}
                            updateProducts={updateDraftProductListInfo}
                          />
                        )}

                        {currentPage == "product-info" && (
                          <UpdateProductInfo
                            productDetails={draftProducts}
                            isLoading={isLoading}
                            setCurrentPage={setCurrentPage}
                            toggleProductRowSelect={toggleProductRowSelect}
                            selectedRowCount={selectedRows}
                            updateProducts={updateDraftProductListInfo}
                            unitOfMeasurementData={unitOfMeasurementData}
                            openQuickUpdateModel={openQuickProductUpdateModel}
                            setOpenQuickUpdateModel={
                              setOpenQuickProductUpdateModel
                            }
                            catalogPartner={
                              commerceInfo?.info?.catalogPartnerInfo?.[0]
                                ?.catalogPartner || ""
                            }
                          />
                        )}

                        {currentPage == "ondc" && (
                          <OndcParameters
                            productDetails={draftProducts}
                            isLoading={isLoading}
                            setCurrentPage={setCurrentPage}
                            toggleProductRowSelect={toggleProductRowSelect}
                            selectedRowCount={selectedRows}
                            updateProducts={updateDraftProductListInfo}
                            openQuickUpdateModel={openQuickOndcParamUpdateModel}
                            setOpenQuickUpdateModel={
                              setOpenQuickOndcParamUpdateModel
                            }
                          />
                        )}

                        {currentPage === "ondcSpecGroup" && (
                          <ONDCSpecGroups
                            productDetails={draftProducts}
                            isLoading={isLoading}
                            setCurrentPage={setCurrentPage}
                            setSelectedProdGroup={setSelectedProdGroup}
                          />
                        )}

                        {currentPage === "addOndcSpecs" && (
                          <AddOndcSpecifications
                            selectedProdGroup={selectedProdGroup}
                            setSelectedProdGroup={setSelectedProdGroup}
                            productDetails={draftProducts}
                            isLoading={isLoading}
                            openQuickSpecUpdateModal={openQuickSpecUpdateModal}
                            setOpenQuickSpecUpdateModal={
                              setOpenQuickSpecUpdateModal
                            }
                            selectedOndcSpecCount={selectedOndcSpecCount}
                            setSelectedOndcSpecCount={setSelectedOndcSpecCount}
                            setIsDynamicSpecEmpty={setIsDynamicSpecEmpty}
                            ondcSpecLoader={ondcSpecLoader}
                            setOndcSpecLoader={setOndcSpecLoader}
                          />
                        )}

                        {currentPage == "done" && (
                          <SkuSyncSuccess
                            productsAdded={productsAdded}
                            onConfirm={clearDataAndGotoCatalog}
                          />
                        )}
                      </Box>

                      {currentPage != "ondc-alert" &&
                        currentPage != "done" &&
                        currentPage != "provide-sku" && (
                          <ActionButtons
                            currentPage={currentPage}
                            hideNextBtn={
                              notSycedProducts?.length == 0 &&
                              currentPage == "sync-sku"
                            }
                            getNextButtonText={() => {
                              return getNextButtonText({
                                currentPage,
                                selectedRowCount: selectedRows,
                                isDynamicSpecEmpty: false,
                                ondcSpecLoader: false,
                                selectedOndcSpecCount: 0,
                              });
                            }}
                            goBack={goBack}
                            handleQuickUpdate={() => {
                              if (selectedRows > 0) {
                                setCategoryError("");
                                if (currentPage == "assign-category") {
                                  setOpenCategoryModal(true);
                                } else {
                                  setOpenQuickProductUpdateModel(true);
                                }
                              } else {
                                setCategoryError(
                                  "Select atleast 1 to assign category"
                                );
                              }
                            }}
                            selectedRowCount={selectedRows}
                            productList={draftProducts || []}
                            handleNext={handleNext}
                            isDisabled={isLoading}
                            isLoading={isLoading}
                            errorMsg={isError}
                            selectedProdGroup={selectedProdGroup}
                            isDynamicSpecEmpty={isDynamicSpecEmpty}
                            handleQuickOndcSpecUpdate={() => {
                              if (selectedOndcSpecCount > 0) {
                                setOndcSpecError("");
                                setOpenQuickSpecUpdateModal(true);
                              } else {
                                setOndcSpecError(
                                  "Select atleast 1 to update specs"
                                );
                              }
                            }}
                            handleQuickOndcParamsUpdate={() => {
                              if (selectedRows > 0) {
                                setOndcSpecError("");
                                setOpenQuickOndcParamUpdateModel(true);
                              } else {
                                setOndcSpecError(
                                  "Select atleast 1 to update specs"
                                );
                              }
                            }}
                          />
                        )}
                    </Box>
                  )}
                </Box>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: whiteColor,
                    border: logoImgborder1,
                    borderRadius: "10px",
                    p: "12px",
                    textAlign: "center",
                    m: "20px 0 50px 0",
                  }}
                >
                  <Box
                    sx={{
                      width: "45px",
                      height: "45px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "25px",
                      backgroundColor: "#E83251",
                      mb: 2,
                    }}
                  >
                    <FileUploadOutlinedIcon
                      sx={{ fontSize: "24px", color: whiteColor }}
                    />
                  </Box>

                  <Typography sx={styles.infoText}>
                    Catalog Sync feature is currently available only on our
                    browser web version.
                  </Typography>

                  <Typography sx={styles.infoText} my={1.5}>
                    For the best experience and to use this feature, please
                    switch to a desktop or laptop computer and access our site
                    through a standard web browser.
                  </Typography>

                  <Typography sx={styles.infoText} mb={1.5}>
                    To view synced products{" "}
                    <span
                      style={{
                        ...styles.infoText,
                        color: "#E83251",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        navigate(
                          `/${sessionStorage.getItem("costboWEBURL")}/catalog`
                        );
                      }}
                    >
                      Click Here
                    </span>
                  </Typography>

                  <Typography sx={styles.infoText}>
                    We appreciate your understanding{" "}
                    <span
                      style={{
                        ...styles.infoText,
                        color: "#E83251",
                        textDecoration: "underline",
                      }}
                    >
                      https://business.costbo.com/
                    </span>
                  </Typography>
                </Box>
              )}
            </>
          )}
        </Box>
      </DashboardLayout>
    </Box>
  );
};

export default SyncNewCatalog;

const styles = {
  container: (isMobile) => ({
    backgroundColor: isMobile ? BGColor02 : greyColor39,
  }),

  content: {
    display: "flex",
    flexDirection: "column",
    gap: { xs: "0px", md: "10px" },
    pt: { xs: 2.5, md: 0 },
  },

  card: {
    bgcolor: whiteColor,
    border: border25,
    p: "20px 20px 15px 20px",
    borderRadius: "14px",
    mt: 3,
  },

  infoText: {
    fontSize: 13,
    fontWeight: "500",
    color: blackShade19,
  },
};
